import { useState } from "react";
import { IIncrementalTableReport } from "../../Interfaces/deltaHedgeSettings";
import DynamicDropdown from "../../Components/Dropdown/DynamicDropdown";
import { getBaseInstruments } from "../../Requests/Order/tradeTableRequests";
import TextInput from "../../Components/TextInput";
import CheckBox from "../../Components/Checkbox";
import Button from "../../Components/Button";
import { addIncrement, editIncrement } from "../../Requests/deltaHedgeSettings";
import { toast } from "react-toastify";
import { packetErrorHandler } from "../../Utils/requestUtils";
import { useAppDispatch, useAppSelector } from "../../App/hooks";
import {
  addEditIncrementalFormValuesChangeHandler,
  setAddEditIncrementalFormValues,
  setHeltaHedgeSettingsAddEditModalFlag,
  setIncrementalEditFlag,
  setIncrementalTableFlag,
} from "../../Features/DeltaHedgeSettings/deltaHedgeSettingsSlice";

const AddIncremental = () => {
  const formValues = useAppSelector(
    (store) => store.deltaHedgeSettingsSlice
  ).addEditIncrementalFormValues;

  const dispatch = useAppDispatch();

  const isEdit = useAppSelector(
    (store) => store.deltaHedgeSettingsSlice.incrementalEditFlag
  );

  const getProperFunction = () => {
    if (isEdit) return editIncrement(formValues);
    return addIncrement(formValues);
  };

  const addHandler = () => {
    getProperFunction()
      .then((resp) => {
        if (resp.data) {
          toast.success(resp.msg);

          dispatch(
            setAddEditIncrementalFormValues({} as IIncrementalTableReport)
          );

          if (isEdit) dispatch(setIncrementalEditFlag(false));

          dispatch(setIncrementalTableFlag(true));
          dispatch(setHeltaHedgeSettingsAddEditModalFlag(false));
        } else toast.error(resp.msg);
      })
      .catch(packetErrorHandler);
  };

  const changeHandler = (name: string, value: any) => {
    dispatch(addEditIncrementalFormValuesChangeHandler({ name, value }));
  };

  return (
    <>
      <DynamicDropdown
        dropdown={{
          name: "baseInsId",
          placeholder: "نماد پایه",
          extraLabel: true,
        }}
        onChange={changeHandler}
        getData={() => getBaseInstruments()}
        value={formValues.baseInsId}
      />

      <TextInput
        label="حداکثر حباب"
        name="maxBubble"
        value={formValues.maxBubble?.toString()}
        kind="number"
        onChange={changeHandler}
        extraLabel
      />

      <TextInput
        label="حداقل پوشش"
        name="minCoverage"
        value={formValues.minCoverage?.toString()}
        kind="percent"
        onChange={changeHandler}
        extraLabel
      />
      <TextInput
        label="مارجین"
        name="margin"
        value={formValues.margin?.toString()}
        kind="priceWithDecimal"
        onChange={changeHandler}
        extraLabel
      />

      <CheckBox
        label="مجاز به خرید سهم پایه"
        name="canBuyBaseIns"
        checked={formValues.canBuyBaseIns}
        onChange={changeHandler}
      />

      <CheckBox
        label="خرید کال فقط در حالت آفست"
        name="buyCallOptionJustInOffsetMode"
        checked={formValues.buyCallOptionJustInOffsetMode}
        onChange={changeHandler}
      />

      <Button
        text={isEdit ? "ویرایش" : "ثبت"}
        onClick={addHandler}
        variant="contained"
      />
    </>
  );
};

export default AddIncremental;
